import { useEffect, useRef } from 'react';

export const useOutsideClick = (callback: () => void) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (ref?.current && !ref.current?.contains(e.target as Node)) {
        callback();
      }
    };
    const root = document.getElementById('root');
    if (!root) return;
    root.addEventListener('click', handleClick);
    return () => {
      root.removeEventListener('click', handleClick);
    };
  }, [callback]);

  return { ref };
};
